import React, { useEffect, useMemo, useState, useRef } from "react";
import theme from "../../../styles/theme"; // Import des styles globaux
import LeftPanelStyles from "../json/LeftPanelStyles.json"; // Import des styles depuis le JSON

// ---------------------------------------------------
// TEMPLATE BOARD — Composant réutilisable avec importation des styles JSON
// ---------------------------------------------------
const T = {
  text: theme?.colors?.text?.primary || "#164D63",
  soft: theme?.colors?.text?.small || "#5C7A89",
  verySoft: theme?.colors?.text?.verysmall || "#7D97A1",
  bg: theme?.colors?.background?.surface || "#ffffff",
  panel: theme?.colors?.background?.panel || "#f1f3f6",
  border: theme?.colors?.borders?.default || "#d6dee4",
  corelia: theme?.colors?.text?.corelia || "#0e3f56",
  green: theme?.colors?.text?.green || "#1A8C74",
  blueText: theme?.Generic?.blue?.pastel?.text || "#1E5066",
  greyText: theme?.Generic?.grey?.pastel?.text || "#3F5D6E",
};

const FILTER_OPTIONS = ["All", "Type", "Status"]; // Options de filtre génériques

const S = {
  page: LeftPanelStyles.PS.container,
  topBar: LeftPanelStyles.PS.topBar,
  topLabel: LeftPanelStyles.PS.topLabel,
  filterSelect: LeftPanelStyles.PS.filterSelect,
  containerEmpty: LeftPanelStyles.PS.containerEmpty,
  content: LeftPanelStyles.PS.content,
};

// ---------------------------------------------------
// Template Principal du Panneau
// ---------------------------------------------------
const LeftPanel_102_ZoneA1 = ({
  activeFilter = "All", // Le filtre actif
  onBannerDataChange, // Fonction de callback pour gérer les données du banner
  data = [], // Données pour le tableau
}) => {
  const [selectedRows, setSelectedRows] = useState([]); // Gestion des lignes sélectionnées
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Ouverture du menu de filtre
  const menuRef = useRef(null); // Référence pour le menu

  // ---------------------------------------------------
  // Filtrage des lignes selon le filtre actif
  // ---------------------------------------------------
  const filteredRows = useMemo(() => {
    return data.filter((row) => row.filter === activeFilter); // Filtre les données selon le critère actif
  }, [data, activeFilter]);

  // ---------------------------------------------------
  // Gestion des actions dynamiques (ex: changement de valeur, ajout de règles)
  // ---------------------------------------------------
  const handleRowChange = (id, field, value) => {
    // Met à jour les données du tableau
    setSelectedRows(prevRows => 
      prevRows.map(row => row.id === id ? { ...row, [field]: value } : row)
    );
  };

  // ---------------------------------------------------
  // Gestion de l'événement de mise à jour du banner
  // ---------------------------------------------------
  // useEffect(() => {
  //   if (onBannerDataChange) {
  //     const metrics = calculateMetrics(filteredRows); // Calcul des métriques du banner
  //     onBannerDataChange(metrics); // Envoi des données calculées au parent
  //   }
  // }, [filteredRows, onBannerDataChange]);

  // ---------------------------------------------------
  // Retour du Composant avec rendu du Banner et des Containers vides
  // ---------------------------------------------------
  return (
    <div style={S.page}>
      {/* Banner */}
      <div style={S.topBar}>
        <div style={S.topLabel}></div>
        
      </div>

      {/* Conteneur vide sous le Banner */}
      <div style={S.containerEmpty}>
        <h1></h1>
        <div style={S.content}>
          
        </div>
      </div>
    </div>
  );
};

export default LeftPanel_102_ZoneA1;